<template>
  <div class="comp name-card-comp">
    <div class="wrap avatar-wrap">
      <img v-if="!!avatar" class="avatar-img" :src="avatar" />
      <img
        v-else
        class="avatar-img"
        src="../assets/images/default_avatar.png"
      />
      <img
        v-if="is_vip === 1"
        class="vip-img"
        src="../assets/images/vip_normal.png"
        @click.stop.prevent="onOpenClick"
      />
      <img
        v-if="is_vip === 2"
        class="vip-img entp"
        src="../assets/images/vip_ent.png"
        @click.stop.prevent="onOpenClick"
      />
    </div>
    <div class="wrap info-wrap">
      <div class="name-wrap">
        <span class="name-text">{{ nickname }}</span>
        <!-- <span class="company-text" v-if="!!company">{{ `${company}` }}</span> -->
        <!-- <span class="job-text">{{ job }}</span> -->
        <img class="edit-img" src="../assets/images/edit_small.png" @click="onEditClick" v-if="$route.name === 'myIndex'"/>
      </div>
      <div class="text--sub intro-text">{{ introduction }}</div>
    </div>
  </div>
</template>
<script>
import apiUtil from '../utils/apiUtil';
import apiConst from '../consts/apiConst';
export default {
  name: 'nameCard',
  props: {
    userInfo: {
      type: Object,
      default: () => ({})
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      avatar: '',
      nickname: '',
      introduction: '',
      job: '',
      company: '',
      is_vip: 0
    };
  },
  created() {
    if (!this.userInfo || !this.userInfo.action_id) {
      this.init();
    } else {
      const { action_id, is_admin_publish } = this.userInfo;
      this.getUserInfo(action_id, is_admin_publish);
    }
  },
 
  methods: {
    async init() {
      const res = await apiUtil.post(apiConst.getProfile, {});
      if (res) {
        const { avatar, nickname, introduction, job, company, is_vip } = res;
        this.avatar = avatar;
        this.nickname = nickname;
        this.introduction = introduction?introduction:'介绍一下自己吧，让大家可以多多了解您！';
        this.job = job;
        this.company = company;
        this.is_vip = is_vip;
      }
    },

    async getUserInfo(action_id, is_admin_publish) {
      const res = await apiUtil.post(apiConst.getUserInfo, {
        action_id,
        is_admin_publish
      });
      if (res) {
        const { avatar, nickname, introduction, job, company, is_vip } = res;
        this.avatar = avatar;
        this.nickname = nickname;
        this.introduction = introduction;
        this.job = job;
        this.company = company;
        this.is_vip = is_vip;
      }
    },

    onOpenClick() {
      this.$router.push('/open');
    },

    onEditClick() {
      this.$router.push('/my/edit');
    }
  }
};
</script>
<style lang="stylus" scoped>
.name-card-comp {
    width: 700px;
    height: 180px;
    padding: 24px 74px;
    display: flex;
    background-color:rgba(248,248,248,1);
    box-shadow:0px 18px 26px -16px rgba(189,202,217,1);
    border-radius:10px;
    .avatar-wrap{
        flex:0 0 100px;
        margin-right: 30px;
        text-align: center;
        .avatar-img{
            display: block;
            width: 100px;
            height: 100px;
            border-radius: 50%;
            margin-top: 5px;
            margin-bottom: 10px;
            overflow: hidden;
        }
        .vip-img{
            display inline-block;
            width: 51px
            height: 23px;
            &.entp{
              width: 72px;
            }
        }
    }
    .info-wrap {
      .name-wrap {
        position: relative;
        display: flex;
        align-items:flex-end;
        margin: 10px 0 20px 0
        .name-text{
        font-size: 30px;
        margin-right: 27px;
        font-weight: bold
        }
        .company-text {
          // margin: 0 20px;
          padding: 2px 0px;
          line-height: 22px;
          // background-color:rgba(0,104,52,.3);
          // border-radius:2px;
          font-size: 24px;

          color: #000
        }

        .job-text {
          padding: 2px 0px;
          line-height: 25px;
          // background-color:rgba(143,195,30,.3);
          // border-radius:2px;
          font-size: 24px;
          color: #000
        }

        .edit-img {
          // position: absolute
          width: 32px;
          height: 32px;
          // margin-left: 27px;
          // bottom: 5px;
          // right: -60px;
        }
      }
      .intro-text {
        font-size: 20px
        height: 48px;
        line-height: 26px;
         word-break:break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;

      }
    }
}
</style>
